import React, { Component } from 'react'
import BubbleButton from '../BubbleButton/BubbleButton'
import { toast } from 'react-toastify'
import InputMask from 'react-input-mask'
import firebase from 'firebase'
import moment from 'moment'
import Lines from '../Lines'


import './styles/ContactFormSectionStyles.css'


class ContactFormSection extends Component {
    constructor(props) {
        super(props)

        this.state = {
            title: '',
            descr: '',
        }
    }

    componentDidMount() {

        const dbRef = firebase.database().ref('sections/ContactFormSection')

        dbRef.on('value', this.setData.bind(this))
    }

    setData(snapshot) {
        const data = snapshot.val()

        if (data) {

            this.setState({
                ...data,
            })
        }
    }

    validateEmail(email) {
        const re = /.+@.+\..+/i;
        return re.test(email)
    }

    validate() {
        const name = this.NameInput.value
        const email = this.EmailInput.value
        const phone = this.PhoneInput.input.value

        if (name === '' && email === '' && phone === '') {
            toast.info("Заполните контактную форму!", {
                position: toast.POSITION.TOP_RIGHT
            })
            return
        }

        if (!name || name === '') {
            toast.error("Поле Имя не заполнено!", {
                position: toast.POSITION.TOP_RIGHT
            })
            return
        }
        if (!email || email === '') {
            toast.error("Поле Email не заполнено!", {
                position: toast.POSITION.TOP_RIGHT
            })
            return
        }
        if (email && email.length > 0 && !this.validateEmail(email)) {
            toast.error("Поле Email не валидно!", {
                position: toast.POSITION.TOP_RIGHT
            })
            return
        }
        if (!phone || phone === '') {
            toast.error("Поле Телефон не заполнено!", {
                position: toast.POSITION.TOP_RIGHT
            })
            return

        }
        
        if (name && name.length > 0 && email && email.length > 0 && phone && phone.length > 0) {

            const now = moment().format('x')

            let newApplication = {
                id: null,
                isNew: true,
                name: name,
                email: email,
                phone: phone,
                date: now
            }

            var id = firebase.database().ref('applications/').push().key
            newApplication.id = id
            const ref = `applications/${id}`

            firebase.database().ref(ref).set(newApplication).then(() => {
                this.NameInput.value = ''
                this.EmailInput.value = ''
                this.PhoneInput.input.value = ''

                fetch(`https://hooks.zapier.com/hooks/catch/2505585/r54c2r?email=${email}`)
                    .then(resp => {
                        if (resp && resp.status === 200) {
                            resp.json()
                                .then(json => {
                                    console.log(json)
                                    toast.success(`${name}, Ваша заявка успешно отправлена`, {
                                        position: toast.POSITION.TOP_RIGHT
                                    })
                                })
                        }
                    })
                    .catch(err => {
                        toast.error(`${name}, Произошла ошибка !`, {
                            position: toast.POSITION.TOP_RIGHT
                        })
                    })

            })
        }
    }

    render() {

        return (
            <div className="ContactFormSectionWrapper">
                <div className="ContactFormSectionWrapperContent">
                    <div className="ContactFormTitle columns is-mobile">
                        <h2 className="column is-11 is-offset-1">{this.state.title}</h2>
                    </div>
                    <div className="ContactFormDescription columns is-mobile">
                        <p className="column is-5 is-offset-1">{this.state.descr}</p>
                    </div>
                    <div className="ContactForm columns is-mobile">
                        <div className="ContactFormWrapper column is-5 is-offset-1 ">
                            <input type="text" className="ContactFormInput" placeholder={'Ваше имя'} ref={(r) => { this.NameInput = r }} />

                            <input type="text" className="ContactFormInput" placeholder={'E-mail'} ref={(r) => { this.EmailInput = r }} />

                            <InputMask
                                className="ContactFormInput"
                                placeholder={'Номер телефона'}
                                mask="+7\(999) 999-99-99"
                                maskChar=" "
                                ref={(r) => { this.PhoneInput = r }}
                            />

                            <BubbleButton
                                title={'КОНСУЛЬТАЦИЯ'}
                                type={'transparent'}
                                onClick={this.validate.bind(this)}
                            />
                        </div>
                    </div>
                </div>
                <Lines opacity={1}  color={'#9ccdfa'}/>
            </div>
        )
    }
}

export default ContactFormSection


// WEBPACK FOOTER //
// ./src/Components/Sections/ContactFormSection.js